import { FunctionComponent } from 'react';
import { useFormContext } from 'react-hook-form';
import { useAsyncSubmitHandler } from '@cbridge-tools/form';
import { DetailsSidebarFormActions } from '@cbridge-modules/details-sidebar';
import { StreamAction, IStreamForm } from '@cbridge-packages/stream';
import { ApiErrorCode } from '@cbridge-packages/api';

export const StreamDetailsToolbarActions: FunctionComponent = () => {
  const { setError } = useFormContext<IStreamForm>();

  const handleServerError = (errorCode?: string, errorMessage?: string, params?: { key: string }) => {
    if (errorCode === ApiErrorCode.FieldNameMustBeUniquePerTenant) {
      const field = (params?.key as keyof IStreamForm) ?? 'name';
      setError(field, { type: 'serverError', message: errorMessage });
      return true;
    }
    return false;
  };

  const handleCreate = useAsyncSubmitHandler(StreamAction.create.started, undefined, handleServerError);

  const handleUpdate = useAsyncSubmitHandler(StreamAction.update.started, undefined, handleServerError);

  return (
    <DetailsSidebarFormActions<IStreamForm>
      onCreate={handleCreate}
      onUpdate={handleUpdate}
    />
  );
};
